import { render, staticRenderFns } from "./sign.vue?vue&type=template&id=0cd3f9c9&scoped=true&"
import script from "./sign.vue?vue&type=script&lang=js&"
export * from "./sign.vue?vue&type=script&lang=js&"
import style0 from "./sign.vue?vue&type=style&index=0&id=0cd3f9c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd3f9c9",
  null
  
)

export default component.exports